import { createFileRoute } from '@tanstack/react-router'

import { DataExtractionContext } from '@/widgets/data-extraction'

export const Route = createFileRoute(
  '/_app/case-management/cases/data-extraction/$caseId/context/$userClientId/$context',
)({
  component: RouteComponent,
})

export const DataExtractionContextRoute = Route

function RouteComponent() {
  const { caseId, userClientId, context } = Route.useParams()

  return <DataExtractionContext caseId={caseId} userClientId={userClientId} context={context} />
}
